<template>
    <div class="zoomable-table" @touchstart="handleTouchStart" @touchmove="handleTouchMove"
      @touchend="handleTouchEnd" :style="{ transform: `scale(${scale})` }">
      <!-- <table>
        <thead>
          <tr>
            <th>Header 1</th>
            <th>Header 2</th>
            <th>Header 3</th>
            <th>Header 3</th>
            <th>Header 3</th>
          </tr>
        </thead>
        <tbody>
          <tr >
            <td>231</td>
            <td>32423</td>
            <td>23532</td>
          </tr>
        </tbody>
      </table> -->
<!-- 家族入谱人数年度变化报告表 -->
      <el-table v-show="activeVal==1" id="table1" row-key="id" class="statisTable" 
        :summary-method="getSummaries" :span-method="objectSpanMethod1" border :data="tableDatas" >
            <el-table-column prop="area" label="所在地">
                <el-table-column prop="guojia" label="国家" width="50"> </el-table-column>
                <el-table-column prop="sheng" label="省" width="100"> </el-table-column>
                <el-table-column prop="shi" label="市" width="150"> </el-table-column>
                <el-table-column prop="xian" label="县/区" width="100"> </el-table-column>
                <el-table-column prop="zhen" label="镇/村" width="110"> </el-table-column>
            </el-table-column>
            <el-table-column label="上年度入谱人数">
                <el-table-column prop="lastYearMemberNum" label="合计" width="50"> </el-table-column>
                <el-table-column prop="lastYearDeadNum" label="已故" width="50"> </el-table-column>
                <el-table-column prop="lastYearLiveNum" label="在世" width="50"> </el-table-column>
            </el-table-column>
            <el-table-column label="年内变化">
                <el-table-column prop="" label="合计">
                    <el-table-column prop="thisYearAddNum" label="" width="70" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="" label="在世人数">
                    <el-table-column prop="thisYearLiveNum" label="小计" width="70" align="center"></el-table-column>
                    <el-table-column prop="thisYearMaleLiveNum" label="男" width="70" align="center"></el-table-column>
                    <el-table-column prop="thisYearFemaleLiveNum" label="女" width="70" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="name" label="已故人数">
                    <el-table-column prop="thisYearDeadNum" label="小计" width="70" align="center"></el-table-column>
                    <el-table-column prop="thisYearMaleDeadNum" label="男" width="70" align="center"></el-table-column>
                    <el-table-column prop="thisYearFemaleDeadNum" label="女" width="70" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="当前入谱人数">
                    <el-table-column prop="" label="合计">
                        <el-table-column prop="allNum" label="" width="70"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="province" label="在世人数">
                        <el-table-column prop="allLiveNum" label="小计" width="70" align="center"></el-table-column>
                        <el-table-column prop="allMaleLiveNum" label="男" width="70" align="center"></el-table-column>
                        <el-table-column prop="allFemaleLiveNum" label="女" width="70" align="center"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="zip" label="已故人数">
                        <el-table-column prop="allDeadNum" label="小计" width="70" align="center"></el-table-column>
                        <el-table-column prop="allMaleDeadNum" label="男" width="70" align="center"></el-table-column>
                        <el-table-column prop="allFemaleDeadNum" label="女" width="70" align="center"></el-table-column>
                    </el-table-column>
                </el-table-column>
            </el-table-column>
      </el-table>  
<!-- 家族入谱在世人员情况统计表 -->
        <el-table v-show="activeVal==2" :summary-method="getSummaries" :span-method="objectSpanMethod1" 
        :data="tableDatas" row-key="id" border>
            <el-table-column prop="guojia,guojiaNum" label="国家" width="100">
                <template slot-scope="scope"> {{ scope.row.guojia }}({{ scope.row.guojiaNum }})</template>
            </el-table-column>
            <el-table-column prop="sheng,shengNum" label="省" width="180">
                <template slot-scope="scope"> {{ scope.row.sheng }}({{ scope.row.shengNum }})</template>
            </el-table-column>
            <el-table-column prop="shi,shiNum" label="市" width="200">
                <template slot-scope="scope"> {{ scope.row.shi }}({{ scope.row.shiNum }})</template>
            </el-table-column>
            <el-table-column prop="xian,xianNum" label="区(县)" width="100">
                <template slot-scope="scope"> {{ scope.row.xian }}({{ scope.row.xianNum }})</template>
            </el-table-column>
            <el-table-column prop="zhen,zhenNum" label="镇(村)" width="200">
                <template slot-scope="scope"> {{ scope.row.zhen }}({{ scope.row.zhenNum }})</template>
            </el-table-column>
        </el-table>
<!-- 家族入谱各世系人数统计表 -->
        <el-table v-show="activeVal==3"  :data="tableDatas" style="width: 400px" border>
            <el-table-column prop="seniority" label="世系" style="width: 100px"> </el-table-column>
            <el-table-column prop="allNum" label="合计" style="width: 100px"> </el-table-column>
            <el-table-column prop="maleNum" label="男" style="width: 100px"> </el-table-column>
            <el-table-column prop="femaleNum" label="女" style="width: 100px"> </el-table-column>
        </el-table>
<!-- 家族入谱在世人员学历情况统计表 -->
        <el-table  v-show="activeVal==4" :data="tableDatas" :summary-method="getSummaries" :span-method="objectSpanMethod1" border style="width: 100%">
            <el-table-column label="所在地" align="center">
                <el-table-column prop="guojia" label="国家" width="80"></el-table-column>
                <el-table-column prop="sheng" label="省" width="180"></el-table-column>
                <el-table-column prop="shi" label="市" width="200"></el-table-column>
                <el-table-column prop="xian" label="县/区" width="150"></el-table-column>
                <el-table-column prop="zhen" label="镇/村" width="250"></el-table-column>
            </el-table-column>
            <el-table-column label="高等教育" align="center">
                <el-table-column prop="boShiNum" label="博士研究生" align="center" width="100"></el-table-column>
                <el-table-column prop="shuoShiNum" label="硕士研究生" align="center" width="100"></el-table-column>
                <el-table-column prop="benKeNum" label="大学本科" align="center" width="90"></el-table-column>
                <el-table-column prop="zhuanKeNum" label="大学专科" align="center" width="90"></el-table-column>
            </el-table-column>
            <el-table-column label="中等教育" align="center">
                <el-table-column prop="zhongZhuanNum" label="中专" align="center" width="60"></el-table-column>
                <el-table-column prop="gaoZhongNum" label="高中" align="center" width="60"></el-table-column>
                <el-table-column prop="chuZhongNum" label="初中" align="center" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="初等教育" align="center">
                <el-table-column prop="xiaoXueNum" label="小学" align="center" width="90"></el-table-column>
            </el-table-column>
            <el-table-column label="未接收教育" align="center">
                <el-table-column prop="banWenMangNum" label="识字" align="center" width="60"></el-table-column>
                <el-table-column prop="wenMangNum" label="文盲" align="center" width="60"></el-table-column>
            </el-table-column>
        </el-table>
<!-- 家族入谱在世行政职务人员情况统计表 -->
        <el-table v-show="activeVal==5" :data="tableDatas" style="width: 100%" :summary-method="getSummaries" :span-method="objectSpanMethod1" border>
            <el-table-column prop="date" label="所在地" width="120">
                <el-table-column prop="guojia" label="国家" width="80"></el-table-column>
                <el-table-column prop="sheng" label="省" width="180"></el-table-column>
                <el-table-column prop="shi" label="市" width="200"></el-table-column>
                <el-table-column prop="xian" label="县/区" width="150"></el-table-column>
                <el-table-column prop="zhen" label="镇/村" width="250"></el-table-column>
            </el-table-column>
            <el-table-column label="国家级正职">
                <el-table-column prop="guoJiaZhengNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="guoJiaZhengMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="guoJiaZhengFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="国家级副职">
                <el-table-column prop="guoJiaFuNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="guoJiaFuMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="guoJiaFuFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="省部级正职">
                <el-table-column prop="shengZhengNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="shengZhengMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="shengZhengFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="省部级副职">
                <el-table-column prop="shengFuNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="shengFuMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="shengFuFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="厅局级正职">
                <el-table-column prop="tingZhengNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="tingZhengMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="tingZhengFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="厅局级副职">
                <el-table-column prop="tingFuNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="tingFuMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="tingFuFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="县处级正职">
                <el-table-column prop="xianZhengNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="xianZhengMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="xianZhengFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="县处级副职">
                <el-table-column prop="xianFuNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="xianFuMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="xianFuFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="乡科级正职">
                <el-table-column prop="xiangZhengNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="xiangZhengMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="xiangZhengFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="乡科级副职">
                <el-table-column prop="xiangFuNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="xiangFuMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="xiangFuFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
            <el-table-column label="科员及以下">
                <el-table-column prop="keYuanNum" label="小计" width="60" align="center"></el-table-column>
                <el-table-column prop="keYuanMaleNum" label="男" width="50" align="center"></el-table-column>
                <el-table-column prop="keYuanFemaleNum" label="女" width="50" align="center"></el-table-column>
            </el-table-column>
        </el-table>

<!-- 家族入谱在世专业技术职务人员情况统计表 -->
        <el-table  v-show="activeVal==6" :data="tableDatas" style="width: 100%" :summary-method="getSummaries" :span-method="objectSpanMethod1" border>
            <el-table-column prop="date" label="所在地">
                <el-table-column prop="guojia" label="国家" width="80"></el-table-column>
                <el-table-column prop="sheng" label="省" width="180"></el-table-column>
                <el-table-column prop="shi" label="市" width="200"></el-table-column>
                <el-table-column prop="xian" label="县/区" width="150"></el-table-column>
                <el-table-column prop="zhen" label="镇/村" width="250"></el-table-column>
            </el-table-column>
            <el-table-column prop="allNum" label="合计" width="60" align="center"></el-table-column>
            <el-table-column label="高级职称">
                <el-table-column label="小计">
                    <el-table-column prop="gaoJiNum" label="小计" width="60" align="center"></el-table-column>
                    <el-table-column prop="gaoJiMaleNum" label="男" width="50" align="center"></el-table-column>
                    <el-table-column prop="gaoJiFemaleNum" label="女" width="50" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="正高级">
                    <el-table-column prop="zhengGaoNum" label="小计" width="60" align="center"></el-table-column>
                    <el-table-column prop="zhengGaoMaleNum" label="男" width="50" align="center"></el-table-column>
                    <el-table-column prop="zhengGaoFemaleNum" label="女" width="50" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="副高级">
                    <el-table-column prop="fuGaoNum" label="小计" width="60" align="center"></el-table-column>
                    <el-table-column prop="fuGaoMaleNum" label="男" width="50" align="center"></el-table-column>
                    <el-table-column prop="fuGaoFemaleNum" label="女" width="50" align="center"></el-table-column>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="date" label="中级职称">
                <el-table-column>
                    <el-table-column prop="zhongNum" label="小计" width="60" align="center"></el-table-column>
                    <el-table-column prop="zhongMaleNum" label="男" width="50" align="center"></el-table-column>
                    <el-table-column prop="zhongFemaleNum" label="女" width="50" align="center"></el-table-column>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="date" label="初级职称">
                <el-table-column>
                    <el-table-column prop="chuNum" label="小计" width="60" align="center"></el-table-column>
                    <el-table-column prop="chuMaleNum" label="男" width="50" align="center"></el-table-column>
                    <el-table-column prop="chuFemaleNum" label="女" width="50" align="center"></el-table-column>
                </el-table-column>
            </el-table-column>
        </el-table>
<!-- 家族入谱在世军官职务人员情况统计表 -->
        <el-table v-show="activeVal==7" :data="tableDatas" style="width: 100%" :summary-method="getSummaries" :span-method="objectSpanMethod1" border>
            <el-table-column prop="area" label="所在地">
                <el-table-column prop="guojia" label="国家" width="80"></el-table-column>
                <el-table-column prop="sheng" label="省" width="180"></el-table-column>
                <el-table-column prop="shi" label="市" width="200"></el-table-column>
                <el-table-column prop="xian" label="县/区" width="150"></el-table-column>
                <el-table-column prop="zhen" label="镇/村" width="250"></el-table-column>
            </el-table-column>
            <el-table-column prop="allNum" label="合计" width="60" align="center"></el-table-column>
            <el-table-column prop="junWeiZhuXiNum" label="军委主席" width="60" align="center"></el-table-column>
            <el-table-column prop="junWeiFuZhuXiNum" label="军委副主席 军委委员" width="100" align="center"></el-table-column>
            <el-table-column prop="daJunQuZhengNum" label="大军区军兵种正职" width="90" align="center"></el-table-column>
            <el-table-column prop="daJunQuFuNum" label="大军区军兵种副职" width="90" align="center"></el-table-column>
            <el-table-column prop="zhengJunNum" label="正军职" width="70" align="center"></el-table-column>
            <el-table-column prop="fuJunNum" label="副军职" width="70" align="center"></el-table-column>
            <el-table-column prop="zhengShiNum" label="正师职" width="70" align="center"></el-table-column>
            <el-table-column prop="fuShiNum" label="副师职" width="70" align="center"></el-table-column>
            <el-table-column prop="zhengTuanNum" label="正团职" width="70" align="center"></el-table-column>
            <el-table-column prop="fuTuanNum" label="副团职" width="70" align="center"></el-table-column>
            <el-table-column prop="zhengYingNum" label="正营职" width="70" align="center"></el-table-column>
            <el-table-column prop="fuYingNum" label="副营职" width="70" align="center"></el-table-column>
            <el-table-column prop="zhengLianNum" label="正连职" width="70" align="center"></el-table-column>
            <el-table-column prop="fuLianNum" label="副连职" width="70" align="center"></el-table-column>
            <el-table-column prop="zhengPaiNum" label="正排职" width="70" align="center"></el-table-column>
            <el-table-column prop="fuPaiNum" label="副排职" width="70" align="center"></el-table-column>
        </el-table>

<!--  -->
        <el-table v-show="activeVal==8" :data="tableDatas" style="width: 100%" border>
            <el-table-column class-name="elChgTbeClmn" prop="date" label="日期" width="120">
                <template slot="header" slot-scope="scope">
                    <div class="elHeadCon">
                        <div class="headerCon1">区域</div>
                        <div class="headerCon2">类型</div>
                        <div class="headerCon3">数量</div>
                        <div class="headerLine1"></div>
                        <div class="headerLine2"></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="date" label="合计"> </el-table-column>
            <el-table-column prop="date" label="大型企业"> </el-table-column>
            <el-table-column prop="date" label="中型企业"> </el-table-column>
            <el-table-column prop="date" label="小型企业"> </el-table-column>
            <el-table-column prop="date" label="微型企业"> </el-table-column>
            <el-table-column prop="date" label="个体工商户"> </el-table-column>
        </el-table>
<!-- 家族入谱迁徙人员情况统计表 -->
        <el-table v-show="activeVal==9" :data="tableDatas" style="width: 720px" border>
            <el-table-column label="迁徙人">
                <el-table-column prop="sx" label="世系" width="100" align="center"></el-table-column>
                <el-table-column prop="name" label="姓名" width="100"></el-table-column>
            </el-table-column>
            <el-table-column prop="qxsj" label="迁徙时间" width="100"></el-table-column>
            <el-table-column prop="qxyy" label="迁徙原因" width="400"></el-table-column>
            <el-table-column prop="qcd" label="迁出地" width="300"></el-table-column>
            <el-table-column prop="qrd" label="迁入地" width="300"></el-table-column>
        </el-table>
<!-- 家族入谱人员分世系（辈分）统计表 -->
        <el-table v-show="activeVal==10" :data="tableDatas" style="width: 612px" border>
            <el-table-column align="center" prop="shiXu" label="辈分（世系）" width="120"></el-table-column>
            <el-table-column align="center" prop="num" label="人数" width="70"></el-table-column>
            <el-table-column align="center" prop="earlyYear" label="最早出生年" width="100"></el-table-column>
            <el-table-column align="center" prop="lateYear" label="最晚出生年" width="100"></el-table-column>
            <el-table-column align="center" prop="ageDifference" label="同辈最大年龄差" width="140"></el-table-column>
        </el-table>

    <!--家族入谱人员出生年份统计表-->
        <el-table v-show="activeVal==11" :data="tableDatas"  style="width: 400px" border>
            <el-table-column prop="year" label="年份" style="width: 100px;" align="center">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.year }}年</span>
                </template>
            </el-table-column>
            <el-table-column label="人数">
                <el-table-column prop="num" label="小计" style="width: 100px" align="center">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.num }}人</span>
                    </template>
                </el-table-column>
                <el-table-column prop="maleNum" label="男" style="width: 100px" align="center">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.maleNum }}人</span>
                    </template>
                </el-table-column>
                <el-table-column prop="femaleNum" label="女" style="width: 100px" align="center">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.femaleNum }}人</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <!-- 查询 -->
        <el-table v-show="activeVal==12" :data="tableDatas" border style="margin-top:10px">
            <el-table-column prop="xm" label="姓名" width="100px"></el-table-column>
            <el-table-column label="性别" width="60px">
                <template slot-scope="scope">
                    <span v-if="scope.row.sex == 1">女</span>
                    <span v-else>男</span>
                </template>
            </el-table-column>
            <el-table-column label="世序" width="100px">
                <template slot-scope="scope">
                    <span>{{ toChies(scope.row.shixu) }}世</span>
                </template>
            </el-table-column>
            <el-table-column label="生故状态" width="100px">
                <template slot-scope="scope">
                    <span v-if="scope.row.sgzt == 1">已故</span>
                    <span v-else>在世</span>
                </template>
            </el-table-column>
            <el-table-column prop="qssj" label="去世时间" width="100px"></el-table-column>
            <el-table-column label="操作" width="110px">
                <template slot-scope="scope">
                    <el-button @click="lookClick(scope.row.id)" type="primary" size="small">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
  </template>
  
  <script>

  export default {
    props: {
      tableDatas: Array,
      activeVal:Number
    },
    data() {
      return {
        initialDistance: 0,  // 两指初始距离
        scale: 1,            // 缩放比例
        infoData: "",
        dialogInfo: false,
      };
    },
    mounted(){
        // console.log(this.tableDatas,'----------inputFamilyTable')
        // console.log(this.activeVal,'----------activeVal')
    },
    watch: {
        tableDatas(nweVal,oldVal) {
            // console.log(nweVal,'----nweVal')
            // console.log(oldVal,'----oldVal')
            // console.log(this.tableDatas,'----this.tableDatas')
            if(nweVal!=oldVal){
                this.initialDistance = 0
                this.scale=1
                // alert(1111)
            }else{
                this.initialDistance = 0
                this.scale=1
            }
        }
    },
    methods: {
        toChies(num) {
            var arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
            var arr2 = ["", "十", "百", "千", "万", "十", "百", "千", "亿", "十", "百", "千", "万", "十", "百", "千", "亿"]; //可继续追加更高位转换值
            if (!num || isNaN(num)) {
                return "零";
            }
            var english = num.toString().split("");
            var result = "";
            for (var i = 0; i < english.length; i++) {
                var des_i = english.length - 1 - i; //倒序排列设值
                result = arr2[i] + result;
                var arr1_index = english[des_i];
                result = arr1[arr1_index] + result;
            }
            //将【零千、零百】换成【零】 【十零】换成【十】
            result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十");
            //合并中间多个零为一个零
            result = result.replace(/零+/g, "零");
            //将【零亿】换成【亿】【零万】换成【万】
            result = result.replace(/零亿/g, "亿").replace(/零万/g, "万");
            //将【亿万】换成【亿】
            result = result.replace(/亿万/g, "亿");
            //移除末尾的零
            result = result.replace(/零+$/, "");
            //将【零一十】换成【零十】
            //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
            //将【一十】换成【十】
            result = result.replace(/^一十/g, "十");
            return result;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "合计";
                } else if (index === 2 || index === 7) {
                    const values = data.map((item) => Number(item[column.property]));
                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = "";
                    }
                } else {
                    sums[index] = "";
                }
            });
            return sums;
        },
         // table合并列
         objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let data = []; //拿到当前table中数据
            let cellValue = row[column.property]; //当前位置的值
            let noSortArr = ["guojia", "sheng", "shi", "xian",'zhen']; //需要合并的字段（进行合并行的prop）
            switch (this.active) {
                case 1:
                    data = this.tableDatas //this.inputFamilyTable;
                    break;
                case 2:
                    data = this.tableDatas //this.regionalDistributionTable;
                    noSortArr = ["guojia", "sheng", "shi", "xian", "guojiaNum", "shengNum", "shiNum", "xianNum", "zhenNum"];
                    break;
                case 3:
                    data =  this.tableDatas //this.seniorityTable;
                    break;
                case 4:
                    data =  this.tableDatas //this.educationTable;
                    break;
                case 5:
                    data =  this.tableDatas //this.positionTable;
                    break;
                case 6:
                    data =  this.tableDatas //this.jobtitleTable;
                    break;
                case 7:
                    data =  this.tableDatas //this.militaryTable;
                    break;
                case 8:
                    data =  this.tableDatas //this.inputFamilyTable;
                    break;
                case 9:
                    data =  this.tableDatas //this.migrationTable;
                    break;
                case 10:
                    data =  this.tableDatas //this.generationalTable;
                    break;
                case 11:
                    data =  this.tableDatas //this.bornTable;
                    break;
            }

            if (cellValue && noSortArr.includes(column.property)) {
                let prevRow = data[rowIndex - 1]; //获取到上一条数据
                let nextRow = data[rowIndex + 1]; //下一条数据
                if (prevRow && prevRow[column.property] === cellValue) {
                    //当有上一条数据，并且和当前值相等时
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[column.property] === cellValue) {
                        //当有下一条数据并且和当前值相等时,获取新的下一条
                        nextRow = data[++countRowspan + rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        },
        objectSpanMethod1({ row, column, rowIndex, columnIndex }) {
            let data = []; //拿到当前table中数据
            switch (this.activeVal) {
                case 1:
                    data = this.tableDatas;
                    break;
                case 2:
                    data = this.tableDatas;
                    break;
                case 4:
                    data = this.tableDatas;
                    break;
            }
            if (columnIndex == 0) {
                let prevRow = data[rowIndex - 1]; //获取到上一条数据
                let nextRow = data[rowIndex + 1]; //下一条数据
                if (prevRow && prevRow[column.property] === row[column.property]) {
                    //当有上一条数据，并且和当前值相等时
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[column.property] === row[column.property]) {
                        //当有下一条数据并且和当前值相等时,获取新的下一条
                        nextRow = data[++countRowspan + rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            } else if (columnIndex == 1) {
                let prevRow = data[rowIndex - 1]; //获取到上一条数据
                let nextRow = data[rowIndex + 1]; //下一条数据
                let nowStr = row["guojia"] + row["sheng"];
                if (prevRow && prevRow["guojia"] + prevRow["sheng"] === nowStr) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow["guojia"] + nextRow["sheng"] === nowStr) {
                        //当有下一条数据并且和当前值相等时,获取新的下一条
                        nextRow = data[++countRowspan + rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            } else if (columnIndex == 2) {
                let prevRow = data[rowIndex - 1]; //获取到上一条数据
                let nextRow = data[rowIndex + 1]; //下一条数据
                let nowStr = row["guojia"] + row["sheng"] + row["shi"];
                if (prevRow && prevRow["guojia"] + prevRow["sheng"] + prevRow["shi"] === nowStr) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow["guojia"] + nextRow["sheng"] + nextRow["shi"] === nowStr) {
                        //当有下一条数据并且和当前值相等时,获取新的下一条
                        nextRow = data[++countRowspan + rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            } else if (columnIndex == 3) {
                let prevRow = data[rowIndex - 1]; //获取到上一条数据
                let nextRow = data[rowIndex + 1]; //下一条数据
                let nowStr = row["guojia"] + row["sheng"] + row["shi"] + row["xian"];
                if (prevRow && prevRow["guojia"] + prevRow["sheng"] + prevRow["shi"] + prevRow["xian"] === nowStr) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow["guojia"] + nextRow["sheng"] + nextRow["shi"] + nextRow["xian"] === nowStr) {
                        //当有下一条数据并且和当前值相等时,获取新的下一条
                        nextRow = data[++countRowspan + rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        },
      // 获取两指间的距离
      getDistance(touch1, touch2) {
        const dx = touch1.pageX - touch2.pageX;
        const dy = touch1.pageY - touch2.pageY;
        return Math.sqrt(dx * dx + dy * dy);
      },
      // 处理 touchstart 事件
      handleTouchStart(e) {
        if (e.touches.length === 2) {
          this.initialDistance = this.getDistance(e.touches[0], e.touches[1]);
        }
      },
      // 处理 touchmove 事件
      handleTouchMove(e) {
        if (e.touches.length === 2) {
          const currentDistance = this.getDistance(e.touches[0], e.touches[1]);
          this.scale = Math.min(Math.max(currentDistance / this.initialDistance, 0.5), 2);  // 限制缩放范围
        }
      },
      // 处理 touchend 事件
      handleTouchEnd() {
        // 手指抬起后可以进一步处理，比如保持缩放比例
        // alert(111)
      },
      lookClick(id) {
        this.$emit('viewClick', id);
      }
    }
  };
  </script>
  
  <style scoped>
  .zoomable-table {
    transition: transform 0.5s ease;  /* 添加平滑过渡效果 */
    transform-origin: top center;
    width: 100%;
    overflow: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/zoomTable.vue